import React from "react";
import { motion } from "framer-motion";

/**
 * Animated neon audio waveform — echoing the wave inside the Subspace logo.
 * Variants: 'line' (single horizontal wave), 'bars' (equalizer bars).
 */
const AudioWaveDecor = ({
  variant = "line",
  bars = 32,
  color = "from-fuchsia-500 via-violet-500 to-cyan-400",
  className = "",
  height = 40,
}) => {
  if (variant === "bars") {
    return (
      <div
        className={`flex items-center justify-center gap-[3px] ${className}`}
        style={{ height }}
        data-testid="audio-wave-bars"
      >
        {Array.from({ length: bars }).map((_, i) => (
          <motion.span
            key={i}
            className={`w-[3px] rounded-full bg-gradient-to-t ${color}`}
            style={{
              boxShadow: "0 0 8px rgba(168,85,247,0.6)",
            }}
            animate={{
              height: [
                `${15 + Math.random() * 30}%`,
                `${50 + Math.random() * 50}%`,
                `${15 + Math.random() * 30}%`,
              ],
            }}
            transition={{
              duration: 1 + Math.random() * 0.8,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.04,
            }}
          />
        ))}
      </div>
    );
  }

  // SVG line waveform similar to logo
  return (
    <svg
      viewBox="0 0 400 60"
      className={className}
      style={{ height, width: "100%" }}
      data-testid="audio-wave-line"
    >
      <defs>
        <linearGradient id="waveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="35%" stopColor="#8b5cf6" />
          <stop offset="65%" stopColor="#d946ef" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
        <filter id="waveGlow">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <motion.path
        d="M0,30 L40,30 L60,10 L80,50 L100,5 L120,55 L140,15 L160,45 L180,25 L200,35 L220,12 L240,48 L260,20 L280,40 L300,28 L320,32 L360,30 L400,30"
        fill="none"
        stroke="url(#waveGrad)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#waveGlow)"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
      />
    </svg>
  );
};

export default AudioWaveDecor;
